import { Link } from 'react-router-dom';

import Input from 'components/input/input';
import DateTimePicker from 'components/date_time_picker/date_time_picker';
import Select from 'components/select/select';
import CustomerSelect from 'components/select/customer_select';
import IntellioWarning from 'components/intelio_warning/account';
import Button from 'components/button';

import { ReactComponent as ArrowRightSVG } from 'icons/arrow-right.svg';

const ViewComponent = ({
  onCustomerChange,
  onCustomerSelectChange,
  onActChange,
  onSubmit,
  customer,
  act,
  onDateChange,
  hidden,
  loading,
  error,
  actSelectOptions,
  validation,
  validationText,
}) => {
  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header">
          <h2 className="th-canvas-title">
            <Link to="/invoices">Invoices</Link>
            <span>
              <ArrowRightSVG />
            </span>
            Create
          </h2>
          <section className="view-actions">
            <Button
              className="btn-green"
              label="Create"
              color="green"
              loading={loading}
              onClick={onSubmit}
            />
          </section>
        </header>

        {error && (
          <IntellioWarning
            title="There was an error creating the invoice!"
            message={error}
          />
        )}

        <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column">
          <div className="w-100 flex flex-row items-start justify-between margin-between">
            <div className="w-100">
              <div className="w-100">
                <CustomerSelect
                  className="customer-select"
                  valid={validation.customer}
                  validationText="This question is required"
                  label="Customer*"
                  value={customer}
                  onChange={onCustomerSelectChange}
                />
              </div>
              <div className="w-100 flex justify-between margin-between">
                <Input
                  name="firstName"
                  valid={validation.firstName}
                  validationText="This question is required"
                  label="First Name*"
                  value={customer.firstName}
                  onChange={onCustomerChange}
                />
                <Input
                  name="lastName"
                  valid={validation.lastName}
                  validationText="This question is required"
                  label="Last Name*"
                  value={customer.lastName}
                  onChange={onCustomerChange}
                />
              </div>
              <div className="w-100 flex justify-between margin-between">
                <Input
                  name="carteVitale"
                  valid={validation.carteVitale}
                  validationText={validationText.carteVitale}
                  label="Carte Vitale number*"
                  value={customer.carteVitale}
                  onChange={onCustomerChange}
                />

                <DateTimePicker
                  label="Date of Birth"
                  name="dateOfBirth"
                  valid={validation.dateOfBirth}
                  validationText="This question is required"
                  showYearDropdown={true}
                  showTimeInput={false}
                  value={customer.dateOfBirth}
                  onChange={(value) => onDateChange({ value })}
                />
              </div>
              <div className="w-100">
                <Select
                  label={'Act*'}
                  hidden={hidden}
                  options={actSelectOptions}
                  valid={validation.act}
                  validationText="This question is required"
                  value={act}
                  onChange={onActChange}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
export default ViewComponent;
